import { useState } from 'react'
import { useStackOneHub } from '@stackone/react-hub'
import cx from 'classnames'

import Widget from 'common/components/Widget'
import { useAppSelector } from 'common/hooks/redux'
import { getSelectedAccountName } from 'features/auth/store/authSlice'

import { getReactHubToken } from '../../api'

type Props = {
  id: string
  name: string
  logoUrl?: string
  onSuccess: () => void
}

const IntegrationCard = ({ id, name, logoUrl, onSuccess }: Props) => {
  const [isHovered, setIsHovered] = useState<boolean>(false)

  const { startConnect } = useStackOneHub()
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const accountName = useAppSelector(getSelectedAccountName)
  const firstName = useAppSelector((state) => state.authStates.firstName)
  const lastName = useAppSelector((state) => state.authStates.lastName)

  const onClick = async () => {
    if (accountName) {
      const sessionToken = await getReactHubToken({
        provider: id,
        accountId,
        accountName,
        userName: `${firstName} ${lastName}`,
      })
      startConnect({
        sessionToken,
        onSuccess,
      })
    }
  }

  return (
    <div
      role="presentation"
      className=""
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <Widget
        type={isHovered ? 'raised' : 'basic'}
        className={cx('h-full', { 'cursor-pointer': isHovered })}
      >
        <div className="self-end mb-4">
          <img className="h-10" src={logoUrl} alt={`${name}-logo`} />
        </div>
        <div className="text-coolGray-800 text-base font-medium mb-2">
          {name}
        </div>
      </Widget>
    </div>
  )
}

export default IntegrationCard
